import React from 'react';
import Main from '../../organisms/Main/Main';

function Favourite() {
	return <Main title='Ulubione' fav='true' status='true' />;
}

export default Favourite;
